import { render, staticRenderFns } from "./OrderListHeader.vue?vue&type=template&id=3fa8a2bb&scoped=true&"
import script from "./OrderListHeader.vue?vue&type=script&lang=ts&"
export * from "./OrderListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OrderListHeader.vue?vue&type=style&index=0&id=3fa8a2bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8a2bb",
  null
  
)

export default component.exports